import React, { useContext } from "react";
import { Col, Row, Tag } from "antd";
import {
  FaLink,
  FaYoutube,
  FaSpotify,
  FaSoundcloud,
  FaTwitch,
} from "react-icons/fa";
import { RootContext } from "../../RootContextProvider";
import { MdEmail, MdTitle } from "react-icons/md";
import { SiBandcamp, SiDeezer } from "react-icons/si";
import { IoIosImages } from "react-icons/io";
import PremiumTheme from "../Billing/PremiumTheme";

const BlockPicker = ({ setDisplayBlockPicker, setCurrentLinkType }) => {
  const { account } = useContext(RootContext);

  return (
    <>
      <div className="modal-header">
        <Row>
          <Col span={2}></Col>
          <Col span={20}>
            <div className="modal-title">Choisissez un type de bloc</div>
          </Col>
          <Col span={2}></Col>
        </Row>
      </div>
      <div className="modal-body">
        <div className="blocks-modal-picker">
          <div
            className="block-link"
            onClick={() => {
              setCurrentLinkType("regular");
              setDisplayBlockPicker(false);
            }}
          >
            <div className="block-picto">
              <FaLink />
            </div>
            <div className="block-name">Lien simple</div>
          </div>
          <div
            className="block-link"
            onClick={() => {
              setCurrentLinkType("thumbnail");
              setDisplayBlockPicker(false);
            }}
          >
            <Tag color="#FF808B" className="tag-new">
              New
            </Tag>
            <div className="block-picto">
              <IoIosImages />
            </div>
            <div className="block-name">Miniature</div>
            {/* {!account.IsPaying ? (
              <div style={{ marginTop: "-90px", marginRight: "-8px" }}>
                <PremiumTheme fontSize="12px" height="30px" />
              </div>
            ) : (
              ""
            )} */}
          </div>
          <div
            className="block-link"
            onClick={() => {
              setCurrentLinkType("youtube-video");
              setDisplayBlockPicker(false);
            }}
          >
            <div className="block-picto">
              <FaYoutube />
            </div>
            <div className="block-name">Vidéos Youtube</div>
          </div>
          <div
            className="block-link"
            onClick={() => {
              setCurrentLinkType("email");
              setDisplayBlockPicker(false);
            }}
          >
            <div className="block-picto">
              <MdEmail />
            </div>
            <div className="block-name">Email</div>
            {!account.IsPaying ? (
              <div style={{ marginTop: "-90px", marginRight: "-8px" }}>
                <PremiumTheme fontSize="12px" height="30px" />
              </div>
            ) : (
              ""
            )}
          </div>
          {/* <div
            className="block-link"
            onClick={() => {
              setCurrentLinkType("youtube-sub");
              setDisplayBlockPicker(false);
            }}
          >
            <div className="block-picto">
              <FaYoutubeSquare />
            </div>
            <div className="block-name">Follow Youtube</div>
          </div> */}
          <div
            className="block-link"
            onClick={() => {
              setCurrentLinkType("twitch-channel");
              setDisplayBlockPicker(false);
            }}
          >
            <div className="block-picto">
              <FaTwitch />
            </div>
            <div className="block-name">Live Twitch</div>
            {!account.IsPaying ? (
              <div style={{ marginTop: "-90px", marginRight: "-8px" }}>
                <PremiumTheme fontSize="12px" height="30px" />
              </div>
            ) : (
              ""
            )}
          </div>
          <div
            className="block-link"
            onClick={() => {
              setCurrentLinkType("spotify");
              setDisplayBlockPicker(false);
            }}
          >
            <div className="block-picto">
              <FaSpotify />
            </div>
            <div className="block-name">Spotify</div>
            {!account.IsPaying ? (
              <div style={{ marginTop: "-90px", marginRight: "-8px" }}>
                <PremiumTheme fontSize="12px" height="30px" />
              </div>
            ) : (
              ""
            )}
          </div>
          <div
            className="block-link"
            onClick={() => {
              setCurrentLinkType("soundcloud");
              setDisplayBlockPicker(false);
            }}
          >
            <div className="block-picto">
              <FaSoundcloud />
            </div>
            <div className="block-name">SoundCloud</div>
            {!account.IsPaying ? (
              <div style={{ marginTop: "-90px", marginRight: "-8px" }}>
                <PremiumTheme fontSize="12px" height="30px" />
              </div>
            ) : (
              ""
            )}
          </div>
          <div
            className="block-link"
            onClick={() => {
              setCurrentLinkType("bandcamp-audio");
              setDisplayBlockPicker(false);
            }}
          >
            <div className="block-picto">
              <SiBandcamp />
            </div>
            <div className="block-name">Bandcamp</div>
            {!account.IsPaying ? (
              <div style={{ marginTop: "-90px", marginRight: "-8px" }}>
                <PremiumTheme fontSize="12px" height="30px" />
              </div>
            ) : (
              ""
            )}
          </div>
          <div
            className="block-link"
            onClick={() => {
              setCurrentLinkType("deezer");
              setDisplayBlockPicker(false);
            }}
          >
            <div className="block-picto">
              <SiDeezer />
            </div>
            <div className="block-name">Deezer</div>
            {!account.IsPaying ? (
              <div style={{ marginTop: "-90px", marginRight: "-8px" }}>
                <PremiumTheme fontSize="12px" height="30px" />
              </div>
            ) : (
              ""
            )}
          </div>
          <div
            className="block-link"
            onClick={() => {
              setCurrentLinkType("divider-title");
              setDisplayBlockPicker(false);
            }}
          >
            <Tag color="#FF808B" className="tag-new">
              New
            </Tag>
            <div className="block-picto">
              <MdTitle />
            </div>
            <div className="block-name">Titre</div>
            {/* {!account.IsPaying ? (
              <div style={{ marginTop: "-90px", marginRight: "-8px" }}>
                <PremiumTheme fontSize="12px" height="30px" />
              </div>
            ) : (
              ""
            )} */}
          </div>
        </div>
      </div>
    </>
  );
};

export default BlockPicker;
